import type { FC } from 'react';
import './BrandWordmark.css';

export type BrandWordmarkProps = {
  inverse?: boolean;
};

const BrandWordmark: FC<BrandWordmarkProps> = ({
  inverse = false,
}) => (
  <span className={`brand-wordmark${inverse ? ' brand-wordmark--inverse' : ''}`}>
    <img
      className="brand-wordmark__image"
      src="/brand/zedhaque-monogram.svg"
      width="512"
      height="512"
      alt="ZH"
    />
  </span>
);

export default BrandWordmark;
